// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PlusSquareTwoToneSvg from "@ant-design/icons-svg/es/asn/PlusSquareTwoTone";
import AntdIcon from '../components/AntdIcon';

var PlusSquareTwoTone = function PlusSquareTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PlusSquareTwoToneSvg
  }));
};

PlusSquareTwoTone.displayName = 'PlusSquareTwoTone';
export default React.forwardRef(PlusSquareTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/PlusSquareTwoTone.js
// module id = 1601
// module chunks = 0